/**
 * Utility to clear browser caches that might be causing issues
 */

/**
 * Clear service worker caches
 */
export async function clearServiceWorkerCaches(): Promise<void> {
  try {
    // Check if caches API is available (most modern browsers)
    if ('caches' in window) {
      // Get all cache keys
      const keys = await window.caches.keys();
      console.log('Clearing service worker caches:', keys);
      
      // Delete each cache
      await Promise.all(keys.map(key => window.caches.delete(key)));
      console.log('All service worker caches cleared successfully');
    } else {
      console.log('Caches API not available in this browser');
    }
  } catch (e) {
    console.error('Error clearing service worker caches:', e);
  }
}

/**
 * Clear the browser application cache if available
 */
export function clearAppCache(): void {
  try {
    // applicationCache is deprecated and has been removed from modern browsers
    // We'll just use a more modern approach focused on Service Workers
    console.log('Application cache: Using modern cache clearing approach');
    
    // Modern browsers don't use applicationCache anymore
    // The functionality is replaced by Service Workers and Cache API
    // which are handled in clearServiceWorkerCaches()
  } catch (e) {
    console.error('Error with cache operations:', e);
  }
}

/**
 * Clear all types of cache that might affect the application
 */
export async function clearAllCaches(): Promise<void> {
  try {
    // Clear service worker caches
    await clearServiceWorkerCaches();
    
    // Clear app cache
    clearAppCache();
    
    // Clear localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();
    
    console.log('All browser caches cleared successfully');
  } catch (e) {
    console.error('Error clearing caches:', e);
  }
}

/**
 * Try to unregister all service workers
 */
export async function unregisterServiceWorkers(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      console.log(`Unregistering ${registrations.length} service workers`);
      
      for (const registration of registrations) {
        const result = await registration.unregister();
        console.log(`Service worker unregistered:`, result);
      }
    }
  } catch (e) {
    console.error('Error unregistering service workers:', e);
  }
}